// actions
import {
  TOOLTIP_TOGGLE,
  TOOLTIP_HYDRATE,
} from './actions';

const Tooltip = (state = {
  toggle: false,
  disclaimers: {},
}, action) => {
  switch (action.type) {
    case TOOLTIP_TOGGLE:
      return {
        ...state,
        toggle: action.toggle,
      };
    case TOOLTIP_HYDRATE:
      return {
        ...state,
        disclaimers: {
          ...action.data.disclaimers,
        },
      };
    default:
      return state;
  }
};

export default Tooltip;
